import moment from 'moment-timezone'; // eslint-disable-line
import React, { Component } from 'react';
import Select from 'react-select';
import TimeInput from './TimeInput';
import MenuArrow from '../svg/MenuArrow';

class TimePicker extends Component {
    constructor(props) {
        super(props);

        this.state = {
            format24: this.props.format24,
            modal: false,
        };
    }

    componentDidMount() {
        this.setState({
            hour: moment(`${this.props.messages}Z`)
                .utc()
                .tz(moment.tz.guess())
                .format('hh'),
            minute: moment(`${this.props.messages}Z`)
                .utc()
                .tz(moment.tz.guess())
                .format('mm'),
            am: moment(`${this.props.messages}Z`)
                .utc()
                .tz(moment.tz.guess())
                .format('a'),
        });

        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.messages !== prevProps.messages) {
            let hour;
            if (this.state.format24 === 'true') {
                hour = moment(`${this.props.messages}Z`)
                    .utc()
                    .tz(moment.tz.guess())
                    .format('HH');
            } else {
                hour = moment(`${this.props.messages}Z`)
                    .utc()
                    .tz(moment.tz.guess())
                    .format('hh');
            }
            if (hour !== prevState.hour || moment(`${this.props.messages}Z`)
                .utc()
                .tz(moment.tz.guess())
                .format('mm') !== prevState.minute) {
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    hour,
                    minute: moment(`${this.props.messages}Z`)
                        .utc()
                        .tz(moment.tz.guess())
                        .format('mm'),
                });
            }
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

  handleFocus = () => {
      this.setState({ modal: true });
  }

  handleClickOutside = (event) => {
      if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
          this.setState({ modal: false });
      }
  }

  handle24Change = (e) => {
      if (e !== null) {
          this.setState({ format24: e.value });
          setTimeout(() => {
              this.setState({ modal: true });
          }, 0); // Just enough to push it to the end of queue
      }
  }

  timeChange = (passedState, format24) => {
      this.setState({
          hour: passedState.hourValue,
          minute: passedState.minuteValue,
          am: passedState.am,
      });
      this.props.timeinputchange(passedState, format24);
  }

  changeHour = (value) => {
      this.setState({ hour: value });
  }

  changeMinute = (value) => {
      this.setState({ minute: value });
  }

  changeAM = (value) => {
      this.setState({ am: value });
  }

  arrowRenderer = () => {
      return (<MenuArrow />);
  }

  setWrapperRef = (node) => {
      this.wrapperRef = node;
  }

  render() {
      const pickerStyle = {
          top: this.props.pickerDown ? '55px' : 'auto',
          bottom: this.props.pickerDown ? 'auto' : '55px',
          left: this.state.format24 === 'true' ? '45px' : '85px',
      };
      let hourOptions;
      if (this.state.format24 === 'false') {
          hourOptions = [{
              value: '01',
              label: '01',
          },
          {
              value: '02',
              label: '02',
          },
          {
              value: '03',
              label: '03',
          },
          {
              value: '04',
              label: '04',
          },
          {
              value: '05',
              label: '05',
          },
          {
              value: '06',
              label: '06',
          },
          {
              value: '07',
              label: '07',
          },
          {
              value: '08',
              label: '08',
          },
          {
              value: '09',
              label: '09',
          },
          {
              value: '10',
              label: '10',
          },
          {
              value: '11',
              label: '11',
          },
          {
              value: '12',
              label: '12',
          }];
      } else {
          hourOptions = [
              {
                  value: '00',
                  label: '00',
              },
              {
                  value: '01',
                  label: '01',
              },
              {
                  value: '02',
                  label: '02',
              },
              {
                  value: '03',
                  label: '03',
              },
              {
                  value: '04',
                  label: '04',
              },
              {
                  value: '05',
                  label: '05',
              },
              {
                  value: '06',
                  label: '06',
              },
              {
                  value: '07',
                  label: '07',
              },
              {
                  value: '08',
                  label: '08',
              },
              {
                  value: '09',
                  label: '09',
              },
              {
                  value: '10',
                  label: '10',
              },
              {
                  value: '11',
                  label: '11',
              },
              {
                  value: '12',
                  label: '12',
              },
              {
                  value: '13',
                  label: '13',
              },
              {
                  value: '14',
                  label: '14',
              },
              {
                  value: '15',
                  label: '15',
              },
              {
                  value: '16',
                  label: '16',
              },
              {
                  value: '17',
                  label: '17',
              },
              {
                  value: '18',
                  label: '18',
              },
              {
                  value: '19',
                  label: '19',
              },
              {
                  value: '20',
                  label: '20',
              },
              {
                  value: '21',
                  label: '21',
              },
              {
                  value: '22',
                  label: '22',
              },
              {
                  value: '23',
                  label: '23',
              }];
      }
      const minuteOptions = [
          {
              value: '00',
              label: '00',
          },
          {
              value: '15',
              label: '15',
          },
          {
              value: '30',
              label: '30',
          },
          {
              value: '45',
              label: '45',
          },
      ];

      return (
          <div className="time-picker" id="time-picker" ref={this.setWrapperRef}>
              <TimeInput
                  format24={this.state.format24}
                  hour={this.state.hour}
                  minute={this.state.minute}
                  am={this.state.am}
                  timeinputchange={this.timeChange}
                  onFocus={this.handleFocus}
              />
              {this.state.modal
        && (
            <div
                className={this.state.format24 === 'true' ? 'time-picker__modal twenty-four' : 'time-picker__modal'}
                style={pickerStyle}
            >
                <div className="time-picker__wrapper">
                    <div className="time-picker__header-wrap">
                        <div className="time-picker__header">
                            <div className="time-header">Time</div>
                            <Select
                                arrowRenderer={this.arrowRenderer}
                                isSearchable={false}
                                isClearable={false}
                                className="time-picker"
                                classNamePrefix="time-picking"
                                defaultValue={this.state.format24 === 'true' ? {
                                    value: 'true',
                                    label: '24hr',
                                } : {
                                    value: 'false',
                                    label: '12hr',
                                }}
                                onChange={this.handle24Change}
                                options={[{
                                    value: 'false',
                                    label: '12hr',
                                }, {
                                    value: 'true',
                                    label: '24hr',
                                }]}
                            />
                        </div>
                    </div>
                    <div className="time-picker__body">
                        <div
                            className={this.state.format24 === 'true' ? 'time-picker__hours twenty-four' : 'time-picker__hours'}
                        >
                            <div className="time-hours-header">HH</div>
                            <ul>
                                {hourOptions.map((item) => {
                                    return (
                                        // eslint-disable-next-line
                                        <li
                                            key={item.value}
                                            className={item.value === this.state.hour ? 'active hour' : 'hour'}
                                            onClick={() => {
                                                this.changeHour(item.value);
                                            }}
                                        >
                                            {item.label}
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                        <div className="time-picker__minutes">
                            <div className="time-minutes-header">MM</div>
                            <ul>
                                {minuteOptions.map((item) => {
                                    return (
                                        // eslint-disable-next-line
                                        <li
                                            key={item.value}
                                            className={item.value === this.state.minute ? 'active minute' : 'minute'}
                                            onClick={() => {
                                                this.changeMinute(item.value);
                                            }}
                                        >
                                            {item.label}
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                        {this.state.format24 === 'false'
              && (
                  <div className="time-picker__am">
                      <div className="time-picker__am-header" />
                      <ul>
                          {/* eslint-disable */}
                          <li
                              className={this.state.am === 'am' ? 'active am' : 'am'}
                              onClick={() => {
                                  this.changeAM('am');
                              }}
                          >

am
                          </li>
                          {/* eslint-disable-next-line  */}
                          <li
                              className={this.state.am === 'pm' ? 'active am' : 'am'}
                              onClick={() => {
                                  this.changeAM('pm');
                              }}
                          >

pm
                          </li>
                        {/* eslint-enable */}
                      </ul>
                  </div>
              )}
                    </div>
                </div>
            </div>
        )}
          </div>
      );
  }
}

export default TimePicker;
